import { Mail } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { useEmailHandler } from "../../hooks/useEmailHandler";
import { Tooltip } from "@/components/Tooltip";

interface EmailDropdownProps<TData> {
  email: string;
  emailTemplate?: {
    getSubject: (row: TData) => string;
    getBody: (row: TData) => string;
  };
  rowData?: TData;
}

export const EmailDropdown = <TData,>({ email, emailTemplate, rowData }: EmailDropdownProps<TData>) => {
  const { handleSendEmail } = useEmailHandler(emailTemplate, rowData);

  return (
    <DropdownMenu>
      <Tooltip asChild label="Send email" cursor="pointer" side="bottom">
        <DropdownMenuTrigger asChild>
          <button className="ml-2 pt-2 opacity-0 transition-opacity duration-200 group-hover:opacity-100" aria-label="Send email">
            <Mail className="h-4 w-4 hover:cursor-pointer" />
          </button>
        </DropdownMenuTrigger>
      </Tooltip>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => handleSendEmail(email)} aria-label="Default Email Client">
          Default Email Client
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => handleSendEmail(email, "gmail")} aria-label="Gmail">
          Gmail
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => handleSendEmail(email, "outlook")} aria-label="Outlook">
          Outlook
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => handleSendEmail(email, "yahoo")} aria-label="Yahoo Mail">
          Yahoo Mail
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
